<script>
/**
 * ****************************************************************************
 * @description     :   MainMenu
 * @created at      :   2022/03/24
 * @created by      :   ANS809 – quypn@ans-asia.com
 * @package         :   Best Security
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import libraries
 */
import { mapState, mapMutations } from 'vuex';

import { MSG_TYPE } from '@/utils/messages';

/**
 * import template
 */
import template from './template.html';

/**
 * Define main layout
 */
const ModalMessage = {
    name: 'ModalMessage',
    template: template,
    computed: {
        ...mapState('app', ['modalMessage', 'isShowModalMessage']),
        showModal: {
            get() {
                return this.isShowModalMessage;
            },
            set(value) {
                this.updateShowModalMessage(value);
            }
        },
        showCancel() {
            return (
                this.modalMessage.type == MSG_TYPE.CONFIRM ||
                this.modalMessage.type == MSG_TYPE.WARNING
            );
        },
        showTitle() {
            return this.modalMessage.title && this.modalMessage.title != '';
        }
    },
    methods: {
        ...mapMutations('app', ['hideModalMessage', 'updateShowModalMessage']),
        onClickOk() {
            const callback = this.modalMessage.callback;
            this.hideModalMessage();
            if (callback) {
                callback(true);
            }
        },
        onClickCancel() {
            const callback = this.modalMessage.callback;
            this.hideModalMessage();
            if (callback) {
                callback(false);
            }
        },
        hidePopup() {
            const els = document.getElementsByClassName('datalist-top');
            const length = els.length;
            for (let i = 0; i < length; i++) {
                els[i].style.paddingRight = null;
            }
        },
        showPopup() {
            const paddingRight = window.innerWidth - document.body.clientWidth;
            if (paddingRight > 0) {
                const els = document.getElementsByClassName('datalist-top');
                const length = els.length;
                for (let i = 0; i < length; i++) {
                    els[i].style.paddingRight = paddingRight + 'px';
                }
            }
        }
    }
};
export default ModalMessage;
</script>
